module.exports = __webpack_public_path__ + "img/button-more.ae91e6b6.png";